export const CLUB_OFFER = "Đăng ký nhận ngay 29K";
export const CLUB_KICKER = "Đăng ký";
export const CLUB_HEADLINE = "Nhận ngay 29K";
export const CLUB_ACCENT = "29K";
export const CLUB_TERMS = "Nhận ngay 29.000đ khi tạo tài khoản.";
export const CLUB_DESCRIPTION_OFFER = "đăng ký tặng ngay 29k";
export const CLUB_CTA = "Đăng ký nhận thưởng";

export function isClubHost(hostname, search) {
  const host = String(hostname || "").split(":")[0];
  if (host === "winaz.biz" || host === "www.winaz.biz") return true;
  if (host !== "localhost" && host !== "127.0.0.1") return false;
  return new URLSearchParams(search || "").get("club") === "1";
}

export function shouldWarmDevice(hostname, search) {
  return !isClubHost(hostname, search);
}
